/* eslint-disable */
import { useState, useEffect, useCallback } from 'react';

// ── helpers ──────────────────────────────────────────────────────────────────
const fmtDbTime = (pt) => { if (!pt) return null; const s = String(pt); return `${s.slice(6, 8)}:${s.slice(8, 10)}`; };
const parseHM = (t) => { if (!t) return null; const [h, m] = t.split(':').map(Number); return Number.isNaN(h) ? null : h * 60 + m; };
const fmtHM = (min) => { const x = ((min % 1440) + 1440) % 1440; const h = Math.floor(x / 60), m = x % 60; return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`; };
const catOf = (route) => {
  const n = String(route || '').trim();
  if (/^RE/i.test(n)) return 're';
  if (/^RB/i.test(n)) return 'rb';
  if (/^S/i.test(n)) return 's';
  return 'other';
};

// TripAdvisor category search for a destination city
const shortCity = (name) => String(name || '').replace(/ (Hbf|Bahnhof|Hauptbahnhof).*/, '').trim();
const taUrl = (dest, keyword) =>
  `https://www.tripadvisor.com/Search?q=${encodeURIComponent(`${shortCity(dest)} ${keyword} Germany`)}`;

const CATEGORIES = [
  { label: 'Attractions', keyword: 'attractions', icon: '🗺' },
  { label: 'Restaurants', keyword: 'restaurants', icon: '🍽' },
  { label: 'Outdoor', keyword: 'outdoor activities', icon: '🌲' },
  { label: 'Culture', keyword: 'museums culture', icon: '🎭' },
];

const STYLES = `
.tp-root {
  --bg:#F5F3EF; --surface:#FFFFFF; --surf2:#F3F1ED; --surf3:#ECEAE5;
  --ink:#1C1C1A; --muted:#6B6B67; --faint:#A8A8A4;
  --bdr:rgba(28,28,26,.1); --bdr2:rgba(28,28,26,.18);
  --accent:#E8634A; --accent-lt:#FBE9E0;
  --re-bg:#E8EDF6; --re-fg:#1A3A6E; --rb-bg:#E8F2EC; --rb-fg:#2D6A3F; --s-bg:#F2E8F5; --s-fg:#7B2D8A;
  position: fixed; inset: 0; z-index: 1100; overflow-y: auto;
  background: var(--bg); color: var(--ink); font-family: 'DM Sans', system-ui, sans-serif;
}
.tp-top { position: sticky; top: 0; z-index: 5; display: flex; align-items: center; gap: 12px; padding: 12px 16px; background: rgba(245,243,239,.92); backdrop-filter: blur(10px); border-bottom: 1px solid var(--bdr); }
.tp-back { flex: 0 0 auto; width: 32px; height: 32px; border-radius: 50%; border: none; background: #fff; color: var(--ink); font-size: 18px; cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,.12); }
.tp-summary { min-width: 0; }
.tp-summary .route { font-family: 'Fraunces', serif; font-size: 17px; font-weight: 700; letter-spacing: -.02em; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tp-summary .sub { font-size: 12px; color: var(--muted); }
.tp-body { max-width: 680px; margin: 0 auto; padding: 16px; display: flex; flex-direction: column; gap: 22px; }
.tp-h { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .08em; color: var(--faint); margin: 0 0 10px; }

.tp-dep-card { position: relative; background: var(--surface); border: 1.5px solid var(--bdr); border-radius: 14px; padding: 14px; margin-bottom: 10px; }
.tp-dep-card.next { border-color: var(--accent); }
.tp-next-badge { position: absolute; top: -9px; left: 14px; background: var(--accent); color: #fff; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; padding: 2px 8px; border-radius: 100px; }
.tp-dep-head { display: flex; align-items: baseline; gap: 10px; margin-bottom: 10px; }
.tp-dep-times { font-family: 'Fraunces', serif; font-size: 18px; font-weight: 700; }
.tp-dep-meta { font-size: 12px; color: var(--muted); }
.tp-leg { display: flex; align-items: center; gap: 8px; padding: 3px 0; font-size: 13px; }
.tp-badge { display: inline-block; font-size: 10px; font-weight: 700; border-radius: 5px; padding: 2px 6px; flex: 0 0 auto; }
.tp-badge.re { background: var(--re-bg); color: var(--re-fg); } .tp-badge.rb { background: var(--rb-bg); color: var(--rb-fg); }
.tp-badge.s { background: var(--s-bg); color: var(--s-fg); } .tp-badge.other { background: var(--surf3); color: var(--muted); }
.tp-leg-txt { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.tp-leg-txt b { font-variant-numeric: tabular-nums; }

.tp-ai-card { background: linear-gradient(135deg, #FBE9E0, #F5F3EF); border: 1px solid var(--bdr); border-radius: 14px; padding: 14px; }
.tp-ai-head { display: flex; align-items: center; gap: 7px; margin-bottom: 8px; }
.tp-ai-spark { color: var(--accent); font-size: 15px; }
.tp-ai-label { font-size: 12px; font-weight: 700; color: var(--ink); }
.tp-ai-text { font-size: 14px; line-height: 1.55; color: var(--ink); white-space: pre-wrap; }
.tp-ai-text.dim { color: var(--muted); }

.tp-ta-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.tp-ta-card { display: flex; flex-direction: column; gap: 4px; background: var(--surface); border: 1px solid var(--bdr); border-radius: 12px; padding: 12px; text-decoration: none; color: var(--ink); }
.tp-ta-card:hover { border-color: var(--bdr2); }
.tp-ta-icon { font-size: 20px; }
.tp-ta-name { font-family: 'Fraunces', serif; font-size: 14px; font-weight: 600; }
.tp-ta-link { font-size: 11px; color: var(--accent); font-weight: 600; }

.tp-along-card { background: var(--surface); border: 1px solid var(--bdr); border-radius: 12px; margin-bottom: 8px; overflow: hidden; }
.tp-along-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; width: 100%; padding: 12px 14px; background: none; border: none; cursor: pointer; font-family: 'DM Sans', sans-serif; text-align: left; }
.tp-along-name { font-family: 'Fraunces', serif; font-size: 15px; font-weight: 600; color: var(--ink); }
.tp-along-chev { color: var(--accent); font-size: 12px; }
.tp-along-body { padding: 0 14px 14px; }
.tp-along-summary { font-size: 13px; line-height: 1.5; color: var(--ink); margin-bottom: 10px; white-space: pre-wrap; }
.tp-along-summary.dim { color: var(--muted); }
.tp-along-links { display: flex; flex-wrap: wrap; gap: 8px; }
.tp-along-link { font-size: 12px; color: var(--accent); font-weight: 600; text-decoration: none; background: var(--accent-lt); padding: 4px 10px; border-radius: 100px; }
`;

export default function TripPlan({ path, originStation, onBack, apiFetch, API_BASE }) {
  const finalDestination = path.length ? path[path.length - 1].name : originStation;
  const stopsCount = path.length;

  const [deps, setDeps] = useState({ loading: true, error: null, times: [] });
  const [guide, setGuide] = useState({ loading: true, error: null, text: '' });
  const [openStop, setOpenStop] = useState(null);     // intermediate stop name expanded
  const [summaries, setSummaries] = useState({});     // stop name -> { loading, text, error }

  // ── next departures from the origin ──
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const sr = await apiFetch(`${API_BASE}/stations?q=${encodeURIComponent(originStation)}`);
        const sd = await sr.json();
        const eva = sd.stations?.[0]?.eva;
        if (!eva) throw new Error('station not found');
        const tr = await apiFetch(`${API_BASE}/timetable?eva=${eva}&offset=0`);
        const td = await tr.json();
        const times = (td?.timetable?.s || [])
          .filter((x) => x.dp && x.dp.pt)
          .map((x) => fmtDbTime(x.dp.pt))
          .filter(Boolean)
          .sort((a, b) => a.localeCompare(b));
        const uniq = [...new Set(times)].slice(0, 3);
        if (!cancelled) setDeps({ loading: false, error: uniq.length ? null : 'No departures found', times: uniq });
      } catch (e) {
        if (!cancelled) setDeps({ loading: false, error: 'Could not load departures', times: [] });
      }
    })();
    return () => { cancelled = true; };
  }, [originStation, apiFetch, API_BASE]);

  // ── AI day-trip guide (Edge Function → Gemini) ──
  useEffect(() => {
    let cancelled = false;
    setGuide({ loading: true, error: null, text: '' });
    (async () => {
      try {
        const r = await apiFetch(`${API_BASE}/claude-guide`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ destination: finalDestination, type: 'destination' }),
        });
        const d = await r.json();
        if (!cancelled) setGuide({ loading: false, error: d.text ? null : 'failed', text: d.text || '' });
      } catch {
        if (!cancelled) setGuide({ loading: false, error: 'failed', text: '' });
      }
    })();
    return () => { cancelled = true; };
  }, [finalDestination, apiFetch, API_BASE]);

  // build itinerary legs (cumulative from a start time) for the path
  const buildLegs = useCallback((startHM) => {
    let t = parseHM(startHM);
    const legs = [];
    path.forEach((n, i) => {
      const from = i === 0 ? originStation : path[i - 1].name;
      const durMin = n.legSeconds != null ? Math.round(n.legSeconds / 60) : 0;
      const dep = t;
      const arr = t != null ? t + durMin : null;
      legs.push({ route: n.route, from, to: n.name, dep: dep != null ? fmtHM(dep) : '—', arr: arr != null ? fmtHM(arr) : '—' });
      t = arr;
    });
    const totalMin = path.reduce((s, n) => s + (n.legSeconds != null ? Math.round(n.legSeconds / 60) : 0), 0);
    return { legs, arrival: t != null ? fmtHM(t) : '—', totalMin, changes: Math.max(0, path.length - 1) };
  }, [path, originStation]);

  // ── lazy AI summary for an intermediate stop (Edge Function → Gemini) ──
  const toggleStop = async (name) => {
    setOpenStop((cur) => (cur === name ? null : name));
    if (openStop === name || summaries[name]) return; // closing, or already loaded
    setSummaries((s) => ({ ...s, [name]: { loading: true, error: null, text: '' } }));
    try {
      const r = await apiFetch(`${API_BASE}/claude-guide`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ destination: name, type: 'intermediate' }),
      });
      const d = await r.json();
      setSummaries((s) => ({ ...s, [name]: { loading: false, error: d.text ? null : 'failed', text: d.text || '' } }));
    } catch {
      setSummaries((s) => ({ ...s, [name]: { loading: false, error: 'failed', text: '' } }));
    }
  };

  const intermediates = path.slice(0, Math.max(0, path.length - 1)); // exclude final destination

  return (
    <div className="tp-root" style={{ paddingBottom: '40px' }}>
      <style>{STYLES}</style>

      <div className="tp-top">
        <button className="tp-back" aria-label="Back" onClick={onBack}>‹</button>
        <div className="tp-summary">
          <div className="route">{originStation} → {finalDestination}</div>
          <div className="sub">{stopsCount} stop{stopsCount !== 1 ? 's' : ''}</div>
        </div>
      </div>

      <div className="tp-body">
        {/* next departures */}
        <section>
          <h2 className="tp-h">Next departures</h2>
          {deps.loading && <div className="tp-ai-text dim">Loading departures…</div>}
          {!deps.loading && deps.error && <div className="tp-ai-text dim">{deps.error}</div>}
          {!deps.loading && !deps.error && deps.times.map((t0, i) => {
            const it = buildLegs(t0);
            return (
              <div key={t0} className={`tp-dep-card${i === 0 ? ' next' : ''}`}>
                {i === 0 && <span className="tp-next-badge">Next</span>}
                <div className="tp-dep-head">
                  <span className="tp-dep-times">{t0} → {it.arrival}</span>
                  <span className="tp-dep-meta">{it.totalMin} min · {it.changes} change{it.changes !== 1 ? 's' : ''}</span>
                </div>
                {it.legs.map((leg, li) => (
                  <div className="tp-leg" key={li}>
                    <span className={`tp-badge ${catOf(leg.route)}`}>{leg.route || '?'}</span>
                    <span className="tp-leg-txt">{leg.from} <b>{leg.dep}</b> → {leg.to} <b>{leg.arr}</b></span>
                  </div>
                ))}
              </div>
            );
          })}
        </section>

        {/* AI day trip guide */}
        <section>
          <h2 className="tp-h">Day trip guide</h2>
          <div className="tp-ai-card">
            <div className="tp-ai-head">
              <span className="tp-ai-spark">✦</span>
              <span className="tp-ai-label">AI guide</span>
            </div>
            {guide.error
              ? <div className="tp-ai-text dim">AI guide temporarily unavailable</div>
              : <div className="tp-ai-text">{guide.text || (guide.loading ? 'Writing your guide…' : '')}</div>}
          </div>
        </section>

        {/* TripAdvisor categories */}
        <section>
          <h2 className="tp-h">Explore {shortCity(finalDestination)}</h2>
          <div className="tp-ta-grid">
            {CATEGORIES.map((c) => (
              <a key={c.label} className="tp-ta-card" href={taUrl(finalDestination, c.keyword)} target="_blank" rel="noreferrer">
                <span className="tp-ta-icon">{c.icon}</span>
                <span className="tp-ta-name">{c.label}</span>
                <span className="tp-ta-link">View on TripAdvisor →</span>
              </a>
            ))}
          </div>
        </section>

        {/* along the way */}
        {intermediates.length > 0 && (
          <section>
            <h2 className="tp-h">Along the way</h2>
            {intermediates.map((n) => {
              const open = openStop === n.name;
              const sum = summaries[n.name];
              return (
                <div className="tp-along-card" key={n.name}>
                  <button className="tp-along-head" onClick={() => toggleStop(n.name)}>
                    <span className="tp-along-name">{n.name}</span>
                    <span className="tp-along-chev">{open ? '▴' : '▾'}</span>
                  </button>
                  {open && (
                    <div className="tp-along-body">
                      {sum?.error
                        ? <div className="tp-along-summary dim">AI guide temporarily unavailable</div>
                        : <div className="tp-along-summary">{sum?.text || (sum?.loading ? 'Writing…' : '')}</div>}
                      <div className="tp-along-links">
                        {CATEGORIES.slice(0, 3).map((c) => (
                          <a key={c.label} className="tp-along-link" href={taUrl(n.name, c.keyword)} target="_blank" rel="noreferrer">
                            {c.icon} {c.label}
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </section>
        )}
      </div>
    </div>
  );
}
